var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionListTemplate',{ref:"bank-transactions-list",staticClass:"bank-transactions-list",attrs:{"screenConfig":_vm.setScreenConfig,"setLoading":_vm.setLoading,"persistenceKey":'bank-transactions-list',"rowClick":_vm.rowClickCallBack,"gcSundryTransactionPopupConfig":_vm.gcSundryTransactionPopupConfig}})
}
var staticRenderFns = []

export { render, staticRenderFns }